/* eslint-disable no-console */
import {Routes, subRoutes} from '../../../constants/Routes';
import useUserStore from '../../../store/userStore/userStore';
import {removeSlash} from '../../../utils/removeSlash';

import {PermissionEnum} from './../../../constants/permissionsEnum';

export const permissionsAndRoutes = {
  HOME: {
    permissionKey: PermissionEnum.home,
    route: removeSlash(Routes.HOME)
  },
  DASHBOARD: {
    permissionKey: PermissionEnum.Dashboard,
    route: removeSlash(Routes.DASHBOARD)
  },
  DASHBOARD_METRICS: {
    permissionKey: PermissionEnum.DashboardMetrics,
    route: removeSlash(subRoutes.metrics)
  },
  DASHBOARD_STAKEHOLDER_TRACKING: {
    permissionKey: PermissionEnum.DashboardStakeholderTracking,
    route: removeSlash(subRoutes.stakeholderTracking)
  },
  CONFIGURATOR: {
    permissionKey: PermissionEnum.Configurator,
    route: removeSlash(Routes.CONFIGURATOR)
  },
  CONFIGURATOR_ORG_FACILITY: {
    permissionKey: PermissionEnum.ConfiguratorOrganisationFacilities,
    route: removeSlash(subRoutes.Organisation_Facility)
  },
  CONFIGURATOR_VALUE_CHAIN_MANAGEMENT: {
    permissionKey: PermissionEnum.ConfiguratorValueChainManagement,
    route: removeSlash(subRoutes.Value_chain_management)
  },
  CONFIGURATOR_ORG_HIERARCHY: {
    permissionKey: PermissionEnum.ConfiguratorOrganisationHierarchy,
    route: removeSlash(subRoutes.org_and_process_flow)
  },
  CONFIGURATOR_PROCESS_FLOW: {
    permissionKey: PermissionEnum.ConfiguratorProcessFlow,
    route: removeSlash(subRoutes.process_flow)
  },
  CONFIGURATOR_DATA_MANAGEMENT: {
    permissionKey: PermissionEnum.ConfiguratorDataManagement,
    route: removeSlash(subRoutes.data_management)
  },
  CONFIGURATOR_USER_MANAGEMENT: {
    permissionKey: PermissionEnum.ConfiguratorUserManagement,
    route: removeSlash(subRoutes.userManager)
  },
  ORG_MANAGER: {
    permissionKey: PermissionEnum.OrgManager,
    route: removeSlash(Routes.ORG_MANAGER)
  },
  ORG_MANAGER_INFRA_PROFILE: {
    permissionKey: PermissionEnum.OrgManagerInfrastructureProfile,
    route: removeSlash(subRoutes.infraProfile)
  },
  ORG_MANAGER_ASSET_MANAGER: {
    permissionKey: PermissionEnum.OrgManagerAssetManager,
    route: removeSlash(subRoutes.assetManagement)
  },
  ORG_MANAGER_INVESTMENT: {
    permissionKey: PermissionEnum.OrgManagerInvestment,
    route: removeSlash(subRoutes.investments)
  },
  ORG_MANAGER_PRODUCT: {
    permissionKey: PermissionEnum.OrgManagerProduct,
    route: removeSlash(subRoutes.products)
  },
  NZM: {
    permissionKey: PermissionEnum.NZM,
    route: removeSlash(Routes.NET_ZERO)
  },
  NZM_GENERALIZED: {
    permissionKey: PermissionEnum.NZMGeneralized,
    route: removeSlash(subRoutes.nzmGeneral)
  },
  NZM_UTITLIES: {
    permissionKey: PermissionEnum.NZMUtilities,
    route: removeSlash(subRoutes.nzmUtilities)
  },
  NZM_SUPPLY_CHAIN: {
    permissionKey: PermissionEnum.NZMSupplyChain,
    route: removeSlash(subRoutes.nzmSC)
  },
  NZM_TRAVEL: {
    permissionKey: PermissionEnum.NZMTravel,
    route: removeSlash(subRoutes.nzmTravel)
  },
  NZM_ASSETS: {
    permissionKey: PermissionEnum.NZMAsset,
    route: removeSlash(subRoutes.nzmAM)
  },
  NZM_PRODUCTS: {
    permissionKey: PermissionEnum.NZMProducts,
    route: removeSlash(subRoutes.nzmProduct)
  },
  ESG: {
    permissionKey: PermissionEnum.ESG,
    route: removeSlash(subRoutes.framework)
  },
  ESG_PEER_BENCHMARKING: {
    permissionKey: PermissionEnum.ESG,
    route: removeSlash(subRoutes.peer_bechmarking)
  },
  ESG_GAP_ANALYSIS: {
    permissionKey: PermissionEnum.ESG,
    route: removeSlash(subRoutes.gap_analysis)
  },
  AI_DOCUMENT_MANAGER: {
    permissionKey: PermissionEnum.AIDocumentManager,
    route: removeSlash(Routes.OCR)
  },
  STRATEGY: {
    permissionKey: PermissionEnum.Strategy,
    route: removeSlash(Routes.STRATEGY)
  },
  ACTIVITY_LOG: {
    permissionKey: PermissionEnum.ActivityLog,
    route: removeSlash(Routes.ACTIVITY_LOG)
  },
  REPORT_STUDIO: {
    permissionKey: PermissionEnum.ReportStudio,
    route: removeSlash(Routes.REPORT_STUDIO)
  },
  PLATFORM_EDUCATION: {
    permissionKey: PermissionEnum.PlatformEducation,
    route: removeSlash(Routes.PLATFORM_EDUCATION)
  }
};

export const navPermission = {
  home: [
    permissionsAndRoutes.HOME,
    permissionsAndRoutes.CONFIGURATOR,
    permissionsAndRoutes.CONFIGURATOR_ORG_FACILITY,
    permissionsAndRoutes.CONFIGURATOR_VALUE_CHAIN_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_ORG_HIERARCHY,
    permissionsAndRoutes.CONFIGURATOR_PROCESS_FLOW,
    permissionsAndRoutes.CONFIGURATOR_USER_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_USER_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_DATA_MANAGEMENT,
    permissionsAndRoutes.REPORT_STUDIO
  ],
  ca: [
    permissionsAndRoutes.HOME,
    permissionsAndRoutes.DASHBOARD,
    permissionsAndRoutes.DASHBOARD_METRICS,
    permissionsAndRoutes.DASHBOARD_STAKEHOLDER_TRACKING,
    permissionsAndRoutes.CONFIGURATOR,
    permissionsAndRoutes.CONFIGURATOR_ORG_FACILITY,
    permissionsAndRoutes.CONFIGURATOR_VALUE_CHAIN_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_ORG_HIERARCHY,
    permissionsAndRoutes.CONFIGURATOR_PROCESS_FLOW,
    permissionsAndRoutes.CONFIGURATOR_USER_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_USER_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_DATA_MANAGEMENT,
    permissionsAndRoutes.ORG_MANAGER,
    permissionsAndRoutes.ORG_MANAGER_INFRA_PROFILE,
    permissionsAndRoutes.ORG_MANAGER_ASSET_MANAGER,
    permissionsAndRoutes.ORG_MANAGER_INVESTMENT,
    permissionsAndRoutes.ORG_MANAGER_PRODUCT,
    permissionsAndRoutes.AI_DOCUMENT_MANAGER,
    permissionsAndRoutes.NZM,
    permissionsAndRoutes.NZM_GENERALIZED,
    permissionsAndRoutes.NZM_UTITLIES,
    permissionsAndRoutes.NZM_SUPPLY_CHAIN,
    permissionsAndRoutes.NZM_TRAVEL,
    permissionsAndRoutes.NZM_ASSETS,
    permissionsAndRoutes.NZM_PRODUCTS,
    permissionsAndRoutes.ACTIVITY_LOG,
    permissionsAndRoutes.REPORT_STUDIO
  ],
  esg: [
    permissionsAndRoutes.HOME,
    permissionsAndRoutes.CONFIGURATOR,
    permissionsAndRoutes.CONFIGURATOR_ORG_FACILITY,
    permissionsAndRoutes.CONFIGURATOR_VALUE_CHAIN_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_ORG_HIERARCHY,
    permissionsAndRoutes.CONFIGURATOR_PROCESS_FLOW,
    permissionsAndRoutes.ESG,
    permissionsAndRoutes.ESG_PEER_BENCHMARKING,
    permissionsAndRoutes.ESG_GAP_ANALYSIS,
    permissionsAndRoutes.ACTIVITY_LOG,
    permissionsAndRoutes.REPORT_STUDIO
  ],
  strategy: [
    permissionsAndRoutes.HOME,
    permissionsAndRoutes.DASHBOARD,
    permissionsAndRoutes.DASHBOARD_METRICS,
    permissionsAndRoutes.CONFIGURATOR,
    permissionsAndRoutes.CONFIGURATOR_ORG_FACILITY,
    permissionsAndRoutes.CONFIGURATOR_VALUE_CHAIN_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_ORG_HIERARCHY,
    permissionsAndRoutes.CONFIGURATOR_PROCESS_FLOW,
    permissionsAndRoutes.CONFIGURATOR_USER_MANAGEMENT,
    permissionsAndRoutes.CONFIGURATOR_DATA_MANAGEMENT,
    permissionsAndRoutes.AI_DOCUMENT_MANAGER,
    permissionsAndRoutes.ORG_MANAGER,
    permissionsAndRoutes.ORG_MANAGER_INFRA_PROFILE,
    permissionsAndRoutes.ORG_MANAGER_ASSET_MANAGER,
    permissionsAndRoutes.ORG_MANAGER_INVESTMENT,
    permissionsAndRoutes.ORG_MANAGER_PRODUCT,
    permissionsAndRoutes.NZM,
    permissionsAndRoutes.NZM_GENERALIZED,
    permissionsAndRoutes.NZM_UTITLIES,
    permissionsAndRoutes.NZM_SUPPLY_CHAIN,
    permissionsAndRoutes.NZM_TRAVEL,
    permissionsAndRoutes.NZM_ASSETS,
    permissionsAndRoutes.NZM_PRODUCTS,
    permissionsAndRoutes.STRATEGY,
    permissionsAndRoutes.ACTIVITY_LOG,
    permissionsAndRoutes.REPORT_STUDIO,
    permissionsAndRoutes.PLATFORM_EDUCATION
  ]
};

export const hideNav = (product: string, route: string): boolean => {
  switch (product) {
    case 'ca':
    case 'esg':
    case 'strategy':
      return navPermission[product].some((item) => {
        return (
          item.route === route && checkIfHasPermissions(item.permissionKey)
        );
      });
    default:
      return false;
  }
};

export const sideNavMapping = (
  array: any[],
  product: string,
  isHome: boolean = false
): any[] => {
  return array
    .filter((item) =>
      item?.isNotProduct ? true : isHome ? true : hideNav(product, item.key)
    ) // Filter out items where `hidden` would be true
    .map((item) => {
      if (item.children && item.children.length > 0) {
        return {
          ...item,
          hidden: item?.hidden ?? false,
          children: sideNavMapping(item.children, product, isHome)
        };
      }

      return {...item, hidden: item?.hidden ?? false};
    })
    .filter((item) => {
      return !item.hidden;
    });
};

export const checkIfHasPermissions = (permissionName: string): boolean => {
  const {auth0Permissions} = useUserStore.getState();

  return permissionName === ''
    ? false
    : auth0Permissions.some((permission: string) =>
        permission.includes(permissionName)
      );
};
